import { useEffect } from "react";
import { closePopup, reloadGrid } from "@/helper/DxHelper";
import { Popup } from "devextreme-react";
import CustomButton from "@/components/CustomButton";
import { useStockPriceRegisterDelete } from "@/hooks/useStockPriceRegisterDelete";
import { AxiosError } from "axios";
import { StockPriceRegister } from "@/types/types";
import { PopupRef } from "devextreme-react/cjs/popup";
import { DataGridRef } from "devextreme-react/cjs/data-grid";
import { useAppSelector } from "@/hooks/useAppSelector";

type Props = {
  popupRef: React.RefObject<PopupRef>;
  datagridRef: React.RefObject<DataGridRef<StockPriceRegister, string>>;
};

export default function Delete({ datagridRef, popupRef }: Props) {
  const { editId: stockPriceRegisterId } = useAppSelector((state) => state.stockPriceRegister);

  const {
    mutateAsync: deleteStockEntry,
    data: response,
    isPending,
    isError,
    error,
    isSuccess,
  } = useStockPriceRegisterDelete();

  useEffect(() => {
    if (isSuccess) {
      if (!response?.validation.items?.length) {
        closePopup(popupRef);
      }
    }
  }, [isSuccess]);

  return (
    <Popup
      ref={popupRef}
      width={"fit"}
      height={"fit"}
      showTitle={false}
      showCloseButton={false}
      className="shadow-light"
      onHiding={() => {
        reloadGrid(datagridRef);
      }}
    >
      <div className="flex flex-col gap-5">
        <span className="block text-center text-lg font-medium">
          Do you want to remove this stock price entry?
        </span>
        <div className="flex justify-center gap-4">
          <CustomButton
            text="Cancel"
            onClickHandler={() => {
              closePopup(popupRef);
            }}
            className="w-[7.625rem] !px-2"
          />
          <CustomButton
            text={`${isPending ? "Removing.." : "Remove"}`}
            variant="primary"
            disabled={isPending}
            onClickHandler={() => {
              deleteStockEntry(stockPriceRegisterId);
            }}
            className="w-[7.625rem] !px-2"
          />
        </div>
      </div>
      {isError && error instanceof AxiosError ? <span>{error.message}</span> : null}
    </Popup>
  );
}
